<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                  <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                      <v-toolbar color="grey lighten-3" elevation="1">
                          <bc-btn-back></bc-btn-back>
                          <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <bc-modal-print
                              ref="print"
                              @close-method="file_name = null, $refs.print.close()"
                              :file-name="file_name"
                              :no-button="true"
                          ></bc-modal-print>
                          <bc-btn-refresh v-if="api_key.api_keys_id && api_key.api_keys_id > 0"
                                @invoke-method="dbGetApiKey(true)"
                            ></bc-btn-refresh>
                          <v-menu left content-class="no-stripe" v-if="api_key.api_keys_id && api_key.api_keys_id > 0">
                              <template slot="activator">
                                  <v-btn icon>
                                      <v-icon>more_vert</v-icon>
                                  </v-btn>
                              </template>
                              <v-list>
                                  <v-list-tile @click="printPDF()">
                                      <v-list-tile-title>
                                          Print
                                      </v-list-tile-title>
                                  </v-list-tile>
                                  <template v-if="hasPerm('api_keys.update')">
                                      <v-divider class="ml-3 my-0"></v-divider>

                                      <div v-for="item in api_key_status_options" :key="item.option_id">
                                      <v-list-tile @click="changeStatus(item)" v-if="item.option_id != api_key.status_id">
                                          <v-list-tile-title>
                                              {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                          </v-list-tile-title>
                                      </v-list-tile>
                                      </div>

                                  </template>
                                  <template v-if="hasPerm('api_keys.delete')">
                                      <v-divider class="ml-3 my-0"></v-divider>
                                      <v-list-tile @click="$refs.delete_api_key.openDialog()">
                                          <v-list-tile-title>
                                              Delete
                                          </v-list-tile-title>
                                      </v-list-tile>
                                  </template>
                              </v-list>
                          </v-menu>
                          <bc-tooltip>
                              <template slot="activator">
                                  <v-btn
                                      icon
                                      @mouseup.left="$router.push({ name: 'api_keys' })"
                                  >
                                      <v-icon>close</v-icon>
                                  </v-btn>
                              </template>
                              {{ $t('lang.back_to_list') }}
                          </bc-tooltip>
                      </v-toolbar>
                  </v-layout>
              </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="api_key.status" class="ribbon ribbon-top-right" :class="`ribbon-${api_key.status_class}`"><span class="ribbon-span">{{ api_key.status }}</span></div>
                        <v-form ref="formApiKey">
							<v-flex xs12>
								<v-text-field
									v-focus="api_key_dialog"
									v-model="api_key.api_keys_id"
									:label="`${$t('lang.api_keys_id')} *`"
									:rules="ifValid('api_keys.api_keys_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-autocomplete
									v-model="api_key.company_id"
									:label="$t('lang.company_id')"
									:items="customers"
									item-value="company_id"
									item-text="company"
									:rules="ifValid('api_keys.company_id')"
								></bc-autocomplete>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="api_key.api_key"
									:label="`${$t('lang.api_key')} *`"
									:counter="showCounter(api_key.api_key, 'api_keys.api_key')"
									:rules="ifValid('api_keys.api_key')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="api_key.corporate_id"
									:label="$t('lang.corporate_id')"
									:rules="ifValid('api_keys.corporate_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="api_key.level"
									:label="`${$t('lang.level')} *`"
									:rules="ifValid('api_keys.level')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="api_key.user_id"
									:label="$t('lang.user_id')"
									:rules="ifValid('api_keys.user_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="api_key.api_key"
									:label="`${$t('lang.api_key')} *`"
									:counter="showCounter(api_key.api_key, 'api_keys.api_key')"
									:rules="ifValid('api_keys.api_key')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-select
									v-model="api_key.ignore_limits"
									:label="`${$t('lang.ignore_limits')} *`"
									:items="[]"
									item-value="value"
									item-text="text"
									:rules="ifValid('api_keys.ignore_limits')"
								></bc-select>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="api_key.api_secret"
									:label="`${$t('lang.api_secret')} *`"
									:counter="showCounter(api_key.api_secret, 'api_keys.api_secret')"
									:rules="ifValid('api_keys.api_secret')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-select
									v-model="api_key.is_private_key"
									:label="`${$t('lang.is_private_key')} *`"
									:items="[]"
									item-value="value"
									item-text="text"
									:rules="ifValid('api_keys.is_private_key')"
								></bc-select>
							</v-flex>
							<v-flex xs12>
								<v-textarea
									v-model="api_key.ip_addresses"
									:label="$t('lang.ip_addresses')"
									auto-grow
									rows="1"
									:rules="ifValid('api_keys.ip_addresses')"
								></v-textarea>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="api_key.max_requests_per_hour"
									:label="`${$t('lang.max_requests_per_hour')} *`"
									:rules="ifValid('api_keys.max_requests_per_hour')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="api_key.level"
									:label="`${$t('lang.level')} *`"
									:rules="ifValid('api_keys.level')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="api_key.app_name"
									:label="$t('lang.app_name')"
									:counter="showCounter(api_key.app_name, 'api_keys.app_name')"
									:rules="ifValid('api_keys.app_name')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-select
									v-model="api_key.ignore_limits"
									:label="`${$t('lang.ignore_limits')} *`"
									:items="[]"
									item-value="value"
									item-text="text"
									:rules="ifValid('api_keys.ignore_limits')"
								></bc-select>
							</v-flex>
							<v-flex xs12>
								<bc-select
									v-model="api_key.is_private_key"
									:label="`${$t('lang.is_private_key')} *`"
									:items="[]"
									item-value="value"
									item-text="text"
									:rules="ifValid('api_keys.is_private_key')"
								></bc-select>
							</v-flex>
							<v-flex xs12>
								<v-textarea
									v-model="api_key.ip_addresses"
									:label="$t('lang.ip_addresses')"
									auto-grow
									rows="1"
									:rules="ifValid('api_keys.ip_addresses')"
								></v-textarea>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="api_key.app_name"
									:label="$t('lang.app_name')"
									:counter="showCounter(api_key.app_name, 'api_keys.app_name')"
									:rules="ifValid('api_keys.app_name')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-select
									v-model="api_key.disabled"
									:label="`${$t('lang.disabled')} *`"
									:items="[]"
									item-value="value"
									item-text="text"
									:rules="ifValid('api_keys.disabled')"
								></bc-select>
							</v-flex>


                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'api_keys' })" flat >{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @click="saveApiKeys">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_api_key"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_api_key')"
                :message="$t('lang.delete_api_key_confirm')"
                @onConfirm="deleteApiKeys()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_api_key_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteApiKeyDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            api_key: { },
            file_name: "",
            dbGetApiKey: _.debounce(this.getApiKey, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchApiKey", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.api_key) {
                        this.api_key = this.assignObj2(data.api_key, this.rules_api_keys);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=api_key_status&sort_by=2",
                            method: "get",
                            stateProperty: "api_key_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "api_keys", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchApiKey", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.api_key) {
                        next((vm) => {
                            vm.api_key = vm.assignObj2(data.api_key, vm.rules_api_keys);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=api_key_status&sort_by=2",
                                method: "get",
                                stateProperty: "api_key_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "api_keys", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=api_key_status&sort_by=2",
            method: "get",
            stateProperty: "api_key_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_api_keys: (state) => state.api_keys.rules_api_keys,
            api_key_status_options: (state) => state.settings.api_key_status_options,
            api_keys: (state) => state.api_keys.api_keys,
            selectedApiKey: (state) => state.api_keys.selectedApiKey,

        }),
    },
    methods: {
        ...mapActions([
            "fetchApiKey",
            "saveApiKey",
            "deleteApiKey",
            "printApiKey",
			"fetchCustomers",

        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getApiKey(pg_refresh = false) {
            this.startLoader();

            this.fetchApiKey({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.api_key) {
                    this.api_key = this.assignObj2(data.api_key, this.rules_api_keys);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printApiKey({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.api_key) {
                    if (this.dev_mode) {
                        this.file_name = data.api_key.file_name;
                    } else {
                        this.$refs.print.printReport(data.api_key.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveApiKeys() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formApiKey")) {
                    let body = this.prepForm(this.api_key, this.rules_api_keys);

                    this.saveApiKey({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.api_key) {
                            this.$router.push({ name: "api_key", params: { id: data.api_key.api_keys_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { api_keys_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveApiKeys({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.api_key) {
                    this.api_key = this.assignObj2(data.api_key, this.rules_api_keys);
                }
            });
        },
        deleteApiKeys() {
            this.deleteApiKey({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                console.log(data);
                if (data && data.code == "200") {

                    this.validationOff();
                    this.$router.push({ name: "api_keys" });
                }
                this.toggleModalLoader(false);
            });
        },
        async refresh(force=false) {
            this.startLoader();

            if (force == true) {
                await this.fetchApiKey({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.api_key) {
                        this.api_key = this.assignObj2(data.api_key, this.rules_api_keys);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

if (this.customers === null || force == true) await this.getCustomers();

        },
    },
    mounted() {
        this.refresh();
    },
    created() {
    },
};
</script>
